module.exports = __webpack_public_path__ + "static/img/material_4_1.87918a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/papermaterial/material_4_1.jpg
// module id = dcDZ
// module chunks = 1